// REACT
import React, { Component } from "react";

// GRID
import { Container } from "react-grid-system";

// STYLES
import styled from "styled-components";

export default class Notes extends Component {
  render() {
    const { type, t } = this.props;

    return (
      <Container>
        <ContentNotes>
          <Title>NOTAS:</Title>
          {type === "restaurant" && (
            <span>
              <Text>{t("restaurant_notes_1")}</Text>
              <Text>{t("restaurant_notes_2")}</Text>
              <Text>{t("restaurant_notes_3")}</Text>
            </span>
          )}
          {type === "restaurant_details" && (
            <span>
              <Text>{t("restaurant_details_1")}</Text>
            </span>
          )}
          {type === "product_details" && (
            <span>
              <Text>
                A <span>AHRESP</span> {t("notes_partnership_1")}{" "}
                <span>SOGENAVE</span> {t("notes_partnership_2")}.
              </Text>
            </span>
          )}
          {type === "recipe" && (
            <span>
              <Text>
                {t("notes_specialists")} Ana Soeiro, André Magalhães, Edgardo
                Pacheco, Fátima Moura, Fortunato da Câmara, Francisco Seixas da
                Costa, João Cavaleiro Ferreira, José Quitério, Luis Lavrador,
                Nuno Dinis, Olga Cavaleiro, Paulo Mendonça, Paulo Salvador,
                Virgílio Gomes e Vítor Sobral.
              </Text>
            </span>
          )}
        </ContentNotes>
      </Container>
    );
  }
}

// NOTES
const ContentNotes = styled.div`
  padding-top: 70px;
  padding-bottom: 60px;
`;
const Title = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #666666;
  margin-bottom: 10px;
`;
const Text = styled.div`
  font-size: 12px;
  color: #666666;
  margin-bottom: 10px;
  span {
    font-weight: 600;
  }
`;



// WEBPACK FOOTER //
// ./src/components/notes/notes.component.js